import Matter, { World } from 'matter-js'
import Consts from './MatterConsts'

export default class MatterRope {
  private rope: Matter.Composite

  constructor(world: Matter.World, bd1: Matter.Body, bd2: Matter.Body) {
    const group = Matter.Body.nextGroup(true)
    const startPos = bd1.position
    const endPos = bd2.position
    let nodeIndex = 0
    const nodeCount = 12
    const nodeSize = 3
    const gapX = (Math.abs(startPos.x - endPos.x) - nodeSize * nodeCount * 2) / (nodeCount + 1)
    const gapY = (Math.abs(startPos.y - endPos.y) - nodeSize * nodeCount * 2) / (nodeCount + 1)
    const rope = this.rope = Matter.Composites.stack(startPos.x + gapX, startPos.y + gapY, nodeCount, 1, gapX, gapY, 
      (x, y) => (++nodeIndex) && Matter.Bodies.circle(
        x,y,
        nodeSize, 
        { 
          collisionFilter: { 
            group: group,
            category: Consts.CAT_TEA,
            mask: -1
          }
        }
      )
    )
    Matter.Composites.chain(rope, 0.5, 0, -0.5, 0, { stiffness: 0.7, length: 1, render: { type: 'line' } })
    Matter.Composite.add(rope, Matter.Constraint.create({ 
      bodyB: rope.bodies[0],
      bodyA: bd1,
      pointB: { x: 0, y: 0 },
      pointA: { x: 0, y: 0 }, //{x: rope.bodies[0].position.x, y: rope.bodies[0].position.y },
      stiffness: 1.0
    }))

    const lastBody = rope.bodies[rope.bodies.length - 1]
    Matter.Composite.add(rope, Matter.Constraint.create({ 
      bodyB: lastBody,
      bodyA: bd2,
      pointA: {x: 0, y: 0},
      pointB: {x: 0, y: 0},//{x: lastBody.position.x, y: lastBody.position.y },
      stiffness: 1.0
    }))

    Matter.World.add(world, rope)
  }

  public get points(): Matter.Vector[] { 
    return this.rope.bodies.map(b => b.position)
  }

  public get composite(): Matter.Composite {
    return this.rope
  }

  public scale(v: number) {
    this.rope.bodies.forEach(b => Matter.Body.scale(b, v, v))
  }
}